import { createFeed } from '@mono-widgets/feeds';

export const app = createFeed();
